import { getUserData } from '../modules/collectData.js'

export async function logButtonClick(buttonName, windowName) {
  const { uid, iid, lang, platform, game, signature, tsLog } = getUserData()
  if (!iid || !uid || !lang || !platform || !game || !signature || !tsLog ) { return }
  const apiUrl = import.meta.env.VITE_API_URL
  const url = apiUrl + 'logs' +
  `?game=${game}&platform=${platform}&uid=${uid}&token=${signature}`
  
  let src = platform === '_ios' ? platform.replace('_', '').replace('s', '') : 'an'
  const data = {
    "key": "hwmb",
    "log": {
      "src": src,
      "uid": iid,
      "accountId": uid,
      "gameLanguage": lang,
      "buttonName": buttonName,
      "windowName": windowName,
      "ts": tsLog
    }
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

  } catch (error) {
    return
  }
}
